import React from 'react';
import PropTypes from 'prop-types';

import { GeoSearchBoxCustom } from '@strava/ui/Map';
import I18n from 'utils/I18n';

import styles from './styles.scss';

function AddressTypeAhead({ handleSelectedResult, clearSelectedResult, athleteLocation }) {
  // response: SearchBoxRetrieveResponse | CoordinateRetrieveResponse
  const handleSelectedResultAdapter = (response) => {
    if (response.features.length === 0) {
      return;
    }

    const feature = response.features[0];
    const geocoderResult = {
      center: feature.geometry.coordinates,
      place_name: feature.properties.full_address || feature.properties.name
    };

    handleSelectedResult(geocoderResult);
  };

  const locationTypes = new Set(['street', 'address', 'block']);

  return (
    <div className={styles.typeahead}>
      <GeoSearchBoxCustom
        className={styles.geocoder}
        placeholder={I18n.t(
          'strava.settings.privacy.hide_address.address_placeholder'
        )}
        onRetrieve={handleSelectedResultAdapter}
        options={{
          types: locationTypes,
          language: I18n.language(),
          ...(athleteLocation && { lookAtLngLat: [athleteLocation.lng, athleteLocation.lat] })
        }}
        onClear={clearSelectedResult}
        onLoading={clearSelectedResult}
      />
    </div>
  );
}

AddressTypeAhead.propTypes = {
  handleSelectedResult: PropTypes.func.isRequired,
  clearSelectedResult: PropTypes.func.isRequired,
  athleteLocation: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  })
};

export default AddressTypeAhead;
